import { useEffect, useState } from "@wordpress/element";
import { API } from '../API';
import EntidadesItem from '../EntidadesItem';
import FormSearchEntidades from "../FormSearchEntidades";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

function Entidades({ filterEntidades }) {

  const apiEntidades = new API({ filterEntidades });
  const defaultArgs = {
    posts_per_page: 99,
    filterByTaxonomy: false
  }
  const [totalEntidades, setTotalEntidades] = useState(0);
  const [originalEntidades, setOriginalEntidades] = useState([]);
  const [entidadesQuery, setEntidadesQuery] = useState();
  const [allEntidades, setAllEntidades] = useState([]);

  const searchEntidades = (event) => {

    event.preventDefault();

    if (!entidadesQuery) {
      setTotalEntidades(originalEntidades.length);
      setAllEntidades(originalEntidades);
      return;
    }

    const searchQuery = { ...defaultArgs, search: entidadesQuery };

    apiEntidades.loadContent(searchQuery).then(response => {
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data)
    });

  }

  useEffect(() => {
    apiEntidades.loadContent(defaultArgs).then(response => {
      setOriginalEntidades(response.data);
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data);
    });

  }, []);

  return (
    <>
      <SimpleBar style={{ height: '550px' }}>
        <div className={`content-entidades content-entidades-grid content-entidades-scroll grid-2`}>
          {allEntidades.map(item => {
            return <EntidadesItem key={item.id} id={item.id} title={item.title} logo={item.logo} external_link={item.external_link} />
          })}
        </div>
      </SimpleBar>
    </>
  )

}

export default Entidades;